module.exports = __webpack_public_path__ + "img/Villa_Borna_44.60598d0b.jpg";